module.exports = __webpack_public_path__ + "img/Notification (1).bac51d00.svg";